import { render, staticRenderFns } from "./SenseNewEdit.vue?vue&type=template&id=6dd8caab&"
import script from "./SenseNewEdit.vue?vue&type=script&lang=js&"
export * from "./SenseNewEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports